module.exports = __webpack_public_path__ + "static/media/bills.07202e33.svg";